__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "web-coyote";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bluebeam/react-i18n", "1.4.0", function() { return Promise.all([__webpack_require__.e(169), __webpack_require__.e(67), __webpack_require__.e(996), __webpack_require__.e(490)]).then(function() { return function() { return __webpack_require__(88067); }; }); });
			register("@bluebeam/react-i18n", "2.1.0", function() { return Promise.all([__webpack_require__.e(169), __webpack_require__.e(662), __webpack_require__.e(996)]).then(function() { return function() { return __webpack_require__(66662); }; }); });
			register("@bluebeam/react-skyline", "6.3.0", function() { return Promise.all([__webpack_require__.e(169), __webpack_require__.e(426), __webpack_require__.e(206), __webpack_require__.e(996), __webpack_require__.e(825)]).then(function() { return function() { return __webpack_require__(98426); }; }); });
			register("@emotion/react", "11.13.3", function() { return Promise.all([__webpack_require__.e(294), __webpack_require__.e(996), __webpack_require__.e(384)]).then(function() { return function() { return __webpack_require__(80384); }; }); });
			register("@sentry/browser", "7.119.2", function() { return Promise.all([__webpack_require__.e(857), __webpack_require__.e(629)]).then(function() { return function() { return __webpack_require__(94629); }; }); });
			register("@sentry/react", "7.119.2", function() { return Promise.all([__webpack_require__.e(857), __webpack_require__.e(140), __webpack_require__.e(996), __webpack_require__.e(261)]).then(function() { return function() { return __webpack_require__(55759); }; }); });
			register("@sentry/tracing", "7.114.0", function() { return Promise.all([__webpack_require__.e(47), __webpack_require__.e(558)]).then(function() { return function() { return __webpack_require__(40047); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(996), __webpack_require__.e(59)]).then(function() { return function() { return __webpack_require__(88705); }; }); });
			register("react-router-dom", "5.3.4", function() { return Promise.all([__webpack_require__.e(747), __webpack_require__.e(591), __webpack_require__.e(996), __webpack_require__.e(665)]).then(function() { return function() { return __webpack_require__(29747); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(37953); }; }); });
			register("xstate", "4.38.3", function() { return __webpack_require__.e(759).then(function() { return function() { return __webpack_require__(3759); }; }); });
			initExternal(89393);
			initExternal(53077);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};